import React, { useState } from 'react';

function JourneyBudgetPanel({ budget }) {
	const [tier, setTier] = useState('standard');
	if (!budget) return null;

	const total = budget.items.reduce((sum, item) => sum + (item[tier] || 0), 0);

	return (
		<div className="guided-panel">
			<h3 className="guided-panel__title">Expected budget</h3>
			<p className="guided-panel__intro">Total trip cost estimate (excluding personal shopping).</p>

			<div className="guided-budget__tiers">
				{budget.tiers.map((t) => (
					<button
						key={t.id}
						type="button"
						className={`guided-budget__tier ${tier === t.id ? 'is-active' : ''}`}
						onClick={() => setTier(t.id)}
					>
						<strong>{t.label}</strong>
						<span>{t.range}</span>
						<small>{t.description}</small>
					</button>
				))}
			</div>

			<table className="guided-budget__table">
				<thead>
					<tr>
						<th>Item</th>
						<th>USD</th>
					</tr>
				</thead>
				<tbody>
					{budget.items.map((item) => (
						<tr key={item.id}>
							<td>{item.label}</td>
							<td>${item[tier]}</td>
						</tr>
					))}
					<tr className="guided-budget__total">
						<td><strong>Total</strong></td>
						<td><strong>${total.toLocaleString()}</strong></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
}

export default JourneyBudgetPanel;
